import React from 'react';

const ProjectOverview: React.FC = () => {
  return (
    <div className="app-main">
      {/* Hero: Logo + 公司信息 */}
      <section className="hero-section">
        <div className="hero-branding">
          <img src="/logo.png" alt="Prolockey" className="hero-logo-img" />
          <div className="hero-info-stack">
            <h1>洛科安全防护用品有限公司</h1>
            <span className="hero-tagline">Prolockey · Industrial LOTO Safety Solutions</span>
          </div>
        </div>
        <div className="hero-divider" />
        <div className="hero-system-badge">
          <span className="badge-icon-large">🎬</span>
          <div>
            <strong>视频拍摄任务管理</strong>
            <small>内部执行系统 v1.0</small>
          </div>
        </div>
      </section>

      {/* 4个数据概览卡 */}
      <section className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon red">🎯</div>
          <div className="stat-info">
            <h4>核心目标</h4>
            <div className="stat-value">提升产品力评分</div>
            <div className="stat-desc">2星(76分) → 4星+</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon orange">⚠️</div>
          <div className="stat-info">
            <h4>当前问题</h4>
            <div className="stat-value">视频质量不达标</div>
            <div className="stat-desc">高星产品占比仅 3%</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon green">✅</div>
          <div className="stat-info">
            <h4>拍摄重点</h4>
            <div className="stat-value">产品使用演示</div>
            <div className="stat-desc">安装 → 锁定 → 使用完成</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon blue">🎥</div>
          <div className="stat-info">
            <h4>视频风格</h4>
            <div className="stat-value">干净 / 清晰 / 专业</div>
            <div className="stat-desc">说明书风格，参考国外标准</div>
          </div>
        </div>
      </section>

      {/* 双列: 项目目标 + 拍摄重点 */}
      <div className="grid-2">
        <div className="card">
          <h2 className="section-title"><span className="icon">🎯</span> 项目目标</h2>
          <ul className="info-list">
            <li><span className="info-bullet">①</span><div><span className="info-strong">建立长期可复用的视频素材库</span><br/>减少未来拍摄成本，一次拍摄多平台使用（中国制造网 + 独立站）</div></li>
            <li><span className="info-bullet">②</span><div><span className="info-strong">提升外贸视频质量</span><br/>对标国外工业品视频风格，摆脱"国内工厂感"</div></li>
            <li><span className="info-bullet">③</span><div><span className="info-strong">优化产品使用演示内容</span><br/>这是当前最大短板 — 客户不知道怎么用我们的产品</div></li>
            <li><span className="info-bullet">④</span><div><span className="info-strong">提升中国制造网核心产品星级</span><br/>从 3% 高星占比提升到 30%+，直接影响询盘转化</div></li>
          </ul>
        </div>

        <div className="card">
          <h2 className="section-title"><span className="icon">🔑</span> 本次拍摄重点</h2>
          
          <div style={{ background:'var(--primary-light)', border:'1px solid var(--primary-border)', borderRadius:'var(--radius)', padding:'15px 17px', marginBottom:'16px' }}>
            <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'6px' }}>
              <span style={{ fontSize:'18px' }}>⚠️</span>
              <strong style={{ color:'var(--primary)' }}>不是拍产品展示！是拍使用过程！</strong>
            </div>
            <p style={{ fontSize:'12.5px', color:'var(--text-secondary)', lineHeight:1.65, margin:0 }}>
              我们已有的素材都是"产品摆在那儿好看"，客户看完了还是不会用。<br/>
              这次要拍的是：<strong>如何安装、如何锁定、如何操作</strong>。
            </p>
          </div>

          <ul className="info-list">
            <li><span className="info-bullet">▸</span><div><span className="info-strong">如何安装</span> — 产品到手后第一步怎么做</div></li>
            <li><span className="info-bullet">▸</span><div><span className="info-strong">如何锁定设备</span> — 核心功能演示，必须清晰</div></li>
            <li><span className="info-bullet">▸</span><div><span className="info-strong">操作过程</span> — 动作要慢、要稳、要完整</div></li>
            <li><span className="info-bullet">▸</span><div><span className="info-strong">使用完成效果</span> — 展示锁定后的安全状态</div></li>
          </ul>
        </div>
      </div>

      {/* 双列: 风格说明 + 剪辑规格速查 */}
      <div className="grid-2">
        <div className="card">
          <h2 className="section-title"><span className="icon">🎨</span> 视频风格要求</h2>
          <ul className="info-list">
            <li><span className="info-bullet">✦</span><div><span className="info-strong">干净</span> — 背景简洁统一，不要花里胡哨的转场和特效<br/><span style={{ fontSize:'11.5px', color:'var(--text-muted)' }}>建议使用纯色/浅灰背景布或干净的工位环境</span></div></li>
            <li><span className="info-bullet">✦</span><div><span className="info-strong">清晰</span> — 操作步骤明确，每个动作都要有目的性<br/><span style={{ fontSize:'11.5px', color:'var(--text-muted)' }}>镜头聚焦在操作部位，手部动作要慢</span></div></li>
            <li><span className="info-bullet">✦</span><div><span className="info-strong">专业</span> — 不搞娱乐化，偏说明书/教学片风格<br/><span style={{ fontSize:'11.5px', color:'var(--text-muted)' }}>参考 YouTube 工业品评测视频的叙事方式</span></div></li>
            <li><span className="info-bullet">✦</span><div><span className="info-strong">双语字幕</span> — 关键步骤配中英文字幕<br/><span style={{ fontSize:'11.5px', color:'var(--text-muted)' }}>方便内外贸同时使用</span></div></li>
          </ul>
        </div>

        <div className="card">
          <h2 className="section-title"><span className="icon">📐</span> 剪辑规格速查</h2>
          <div style={{ display:'flex', flexDirection:'column', gap:'13px' }}>
            <div style={{ background:'rgba(231,76,60,0.04)', border:'1px solid rgba(231,76,60,0.12)', borderRadius:'var(--radius)', padding:'14px' }}>
              <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'8px' }}>
                <span className="tag tag-red">竖屏 9:16</span><strong style={{ fontSize:'13px' }}>中国制造网</strong>
              </div>
              <div style={{ display:'flex', gap:'18px', fontSize:'12.5px', color:'var(--text-secondary)' }}>
                <span>时长 <strong style={{ color:'var(--text)' }}>30–45秒</strong></span>
                <span>格式 MP4</span>
                <span>内容: 展示+使用+结果</span>
              </div>
            </div>
            <div style={{ background:'rgba(37,99,235,0.04)', border:'1px solid rgba(37,99,235,0.12)', borderRadius:'var(--radius)', padding:'14px' }}>
              <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'8px' }}>
                <span className="tag tag-blue">横屏 16:9</span><strong style={{ fontSize:'13px' }}>独立站 / 海外平台</strong>
              </div>
              <div style={{ display:'flex', gap:'18px', fontSize:'12.5px', color:'var(--text-secondary)' }}>
                <span>时长 <strong style={{ color:'var(--text)' }}>40–60秒</strong></span>
                <span>格式 MP4</span>
                <span>内容: 介绍+使用演示</span>
              </div>
            </div>
          </div>
          <div className="alert alert-info" style={{ marginTop:'14px' }}>
            <span>💡</span>
            <div><strong>参考视频：</strong>{' '}<a href="https://youtu.be/3EtKcwP4Rpw" target="_blank" rel="noreferrer">YouTube 示例 →</a><br/><span style={{ color:'#3b82f6', fontSize:'11.5px' }}>这是我们要对标的质量标准，请美工在拍摄前务必观看理解</span></div>
          </div>
        </div>
      </div>

      <footer className="app-footer">
        <p>© 2026 Prolockey 洛科安全防护用品有限公司 · 视频拍摄任务管理系统 · 内部使用</p>
      </footer>
    </div>
  );
};

export default ProjectOverview;
